// extracted by mini-css-extract-plugin
export var adminLinks = "linkStyles-module__adminLinks___SDCKS";
export var body = "linkStyles-module__body___Om8mI";
export var body3 = "linkStyles-module__body3___DzbrR";
export var crumb = "linkStyles-module__crumb___Bn6uR";
export var headline1 = "linkStyles-module__headline1___GMUEt";
export var headline3 = "linkStyles-module__headline3___dDtVg";
export var showMore = "linkStyles-module__showMore___nOY7K";